import { Playground } from 'docz';
import { useCookie } from "../../../../../src/index";
import * as React from 'react';
export default {
  Playground,
  useCookie,
  React
};